var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "landing-component-spacer",
    style: _vm.customStyles,
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }